export default __webpack_public_path__ + "static/media/severity-scale.9a37c915.jpg";